import { Trans } from "react-i18next";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import NotificationIcon from "src/images/Icons/newIcons/notifications/notification.svg";
import type { NotificationData } from "./List";
import { Notification } from "./NotificationItem";

interface ReportedErrorResponseNotificationProps {
	notification: NotificationData;
	removeNotification: () => Promise<unknown>;
	className?: string;
}

export function ReportedErrorResponseNotification({
	notification,
	removeNotification,
	className,
}: ReportedErrorResponseNotificationProps) {
	const { openModal } = useModals();

	const redirect = async () => {
		openModal(ModalsNames.QuestionViewModal, {
			questionId: notification.itemId,
		});
	};

	return (
		<Notification
			className={className}
			notification={notification}
			removeNotification={removeNotification}
			onRedirect={redirect}
			Icon={NotificationIcon}
			Primary={
				<Trans
					i18nKey="notifications.reportedErrorResponse.title"
					values={{ username: notification.username }}
					components={[<strong className="text-black" key="i18Key" />]}
				/>
			}
			disabledActionsList={["stopSubscribe"]}
		/>
	);
}
